module.exports = __webpack_public_path__ + "img/tema-1-10.7499a078.svg";